<script>
  import { createNamespacedHelpers } from 'vuex';
  import InputText from './InputText';
  import CustomOptions from './CustomOptions';
  import SymbolsLayout from '../SymbolsLayout';

  const { mapGetters } = createNamespacedHelpers('hitch');

  export default {
    name: 'EditLayout',
    components: {
      InputText,
      CustomOptions,
      SymbolsLayout,
    },
    data() {
      return {
        bundleData: null
      };
    },
    computed: {
      ...mapGetters([
        'getSelectedBaseProduct',
        'getSelectedVariant',
        'getAllProducts',
        'getEntryId',
        'getUserText',
        'getCustomizationStyle',
        'getLargeLetterStyle',
        'getSmallLetterStyle',
        'getLoadingLargeLetters',
        'getLoadingSmallLetters'
      ]),
      /** Determines which letter style to feed to the symbols layout component */
      currentLetterStyleChars() {
        let letterStyleChars = [];
        if (
          this.getCustomizationStyle.value === 'monogram' &&
          (this.getUserText.length === 0 || this.getUserText.length === 2)
        ) {
          letterStyleChars = this.getSmallLetterStyle.chars;
        } else {
          letterStyleChars = this.getLargeLetterStyle.chars;
        }
        return letterStyleChars;
      }
    },
  };
</script>

<template>
  <div class="product-view__edit">
    <div class="letter-edit">

      <div v-if="getSelectedVariant">
        <div class="letter-edit">
          <div class="letter-edit__text">
            <label for="primaryInput">Enter Your 3D Text</label>
            <InputText field-id="primaryInput" />
          </div>
        </div>
        <CustomOptions :variant="getSelectedVariant" />
        <SymbolsLayout
          v-if="!getLoadingLargeLetters && !getLoadingSmallLetters"
          :letters-data="currentLetterStyleChars"
        />
      </div>

      <div v-else class="x-loading">
        <span class="loading" />
      </div>

    </div>
  </div>
</template>
